import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'

import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';

import i18n from './i18n';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';
import CircularRoute from './modules/circular/CircularRoute';
import NewsRoute from './modules/news/NewsRoute';
import ConsultationRoute from './modules/consultation/ConsultationRoute';
import { getBaseName, getSfcBaseName } from './modules/common/Utils';


let routerBasename = getBaseName();
let sfcBasename = getSfcBaseName();

ReactDOM.render(
  <React.StrictMode>
    <Suspense fallback="&nbsp;">
      <BrowserRouter basename={routerBasename}>
        <Switch>
          <Route strict path={"/gateway/:lang(EN|TC)/circular/"} component={CircularRoute}/>
          <Route strict path={"/gateway/:lang(EN|TC)/news-and-announcements/news/"} component={NewsRoute}/>
          <Route strict path={"/gateway/:lang(EN|TC)/consultation/"} component={ConsultationRoute}/>
          <Route strict path={"/gateway/EN/error"} render={() => (window.location = `https://${sfcBasename}/EN/404`)}/>
          <Route strict path={"/gateway/TC/error"} render={() => (window.location = `https://${sfcBasename}/TC/404`)}/>
          <Route exact path="/">
            <Redirect to="/gateway/EN/news-and-announcements/news/"/>
          </Route>
        </Switch>
      </BrowserRouter>
    </Suspense>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
